import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ToastrService from '../../services/toastrService';
import ErrorMessage from '../common/ErrorMessage';
import PasswordStrengthInput from '../common/PasswordStrengthInput';

class SetPassword extends Component {
    constructor(props, context) {
        super(props, context);
        this.onChange = this.onChange.bind(this);
        this.submit = this.submit.bind(this);
        this.state = this.getDefaultState();
    }
    componentDidMount() {
        
    }

    getDefaultState() {
        return { 
            password: '',
            confirmPassword: '',
            error: ''
        };
    }

    onChange(event) {
        const field = event.target.name;
        const value = event.target.value;
        let newState = Object.assign({}, this.state);
		newState[field] = value;
		return this.setState(newState);
    }

    submit(event) {
        event.preventDefault();    
        if(this.state.password !== this.state.confirmPassword) {
            this.setState({ error: 'The new password and confirmation password do not match.' });
        }
        else {
            this.props.actions.setPassword(this.state.password)
            .then(_ => {
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'Your password has been set successfully!');
                this.setState(this.getDefaultState());
                if(this.props.onSuccess) {
                    this.props.onSuccess();
                }
            }) 
            .catch(error => {
                this.setState({ error: error.message });
            });
        }        
    }

    render() {        
        return (
            <React.Fragment>
                <h3 className="subsection">Set password</h3>
                <p className="text-center">
                    You do not have a local password for this site. Add a local password so you can log in without an external login.
                </p>
                <form onSubmit={this.submit}>
                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: '' })} />
                    <fieldset>
                        <div id="divPassword" className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block form-mpassstrength">
                            <PasswordStrengthInput id="password" name="password" required onChange={this.onChange} value={this.state.password} /> 
                            <label className="mdl-textfield__label" htmlFor="password">Password</label>
                        </div>
                        <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block">
                            <input id="confirmPassword" name="confirmPassword" type="password" required className="mdl-textfield__input" value={this.state.confirmPassword} onChange={this.onChange} />    
                            <label className="mdl-textfield__label" htmlFor="confirmPassword">Confirm password</label>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <input type="submit" value="SET PASSWORD" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" />
                        </div>
                    </fieldset>
                </form>
            </React.Fragment>
        );
    }
}

SetPassword.propTypes = {
    onSuccess: PropTypes.func,
    actions: PropTypes.object.isRequired
};

export default SetPassword;